import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import TryItOutButton from './TryItOutButton';
import AuthModeSelector from './AuthModeSelector';
import RiskLevelAlert from './RiskLevelAlert';
import useTryItOutContainerStyles from './TryItOutContainer.styles';
import useTryItOut from '../../hooks/useTryItOut';

/**
 * Props for the TryItOutContainer
 */
export interface TryItOutContainerProps {
  children: React.ReactNode;
}

const TryItOutContainer: FunctionComponent<TryItOutContainerProps> = ({ children }) => {
  const { translate } = useTranslation();
  const { classes } = useTryItOutContainerStyles();
  const { tryItOutOpen: tryItOutEnabled } = useTryItOut();

  return (
    <React.Fragment>
      <Grid container direction='column' gap={2} classes={{ root: classes.tryItOutControls }}>
        <Grid
          item
          container
          alignItems='center'
          justifyContent='space-between'
          classes={{ root: classes.tryItOutHeader }}>
          <Grid item>
            <Typography variant='h5'>{translate('Label.TryItOut')}</Typography>
          </Grid>
          <Grid item>
            <TryItOutButton />
          </Grid>
        </Grid>
        {tryItOutEnabled && (
          <React.Fragment>
            <Grid item>
              <AuthModeSelector />
            </Grid>
            <Grid item>
              <RiskLevelAlert />
            </Grid>
          </React.Fragment>
        )}
      </Grid>

      {children}
    </React.Fragment>
  );
};

export default TryItOutContainer;
